import { render, staticRenderFns } from "./AbkUpcomingEventsBox.vue?vue&type=template&id=73849d9a&scoped=true&"
import script from "./AbkUpcomingEventsBox.vue?vue&type=script&lang=js&"
export * from "./AbkUpcomingEventsBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkUpcomingEventsBox.vue?vue&type=style&index=0&id=73849d9a&scoped=true&lang=scss&"
import style1 from "./AbkUpcomingEventsBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73849d9a",
  null
  
)

export default component.exports